<div class="tool-status" [class]="displayClass" *ngIf="shouldDisplay">
  <mat-icon class="tool-icon" [matTooltip]="tooltip">{{ icon }}</mat-icon>
  <span class="tool-text">
    <ng-container [ngSwitch]="displayMode">
      <!-- Inline: show count -->
      <span *ngSwitchCase="'inline'">
        {{ displayText }}
      </span>
      
      <!-- Compact: show names -->
      <span *ngSwitchCase="'compact'">
        <span *ngFor="let tool of toolCalls; let last = last">
          {{ getToolName(tool) }}<span *ngIf="!last">, </span>
        </span>
      </span>
      
      <!-- Detail: show comprehensive tool execution info -->
      <div *ngSwitchCase="'detail'" class="tool-detail">
        <div class="tool-summary" *ngIf="status === 'executing' && toolCalls.length === 0">
          Using tools...
        </div>
        <div class="tool-list" *ngIf="toolCalls.length > 0">
          <div class="tool-item" *ngFor="let tool of toolCalls">
            <mat-icon class="tool-item-icon" [class.executing]="status === 'executing'">
              {{ getToolIcon() }}
            </mat-icon>
            <span class="tool-item-name">{{ getToolName(tool) }}</span>
            <span class="tool-item-status" [class]="'status-' + status">
              {{ getToolItemStatus() }}
            </span>
          </div>
        </div>
        <div class="tool-summary" *ngIf="toolCalls.length > 1">
          {{ toolCalls.length }} tools {{ getStatusText() }}
        </div>
      </div>
      
      <!-- Off: don't show -->
      <span *ngSwitchDefault></span>
    </ng-container>
  </span>
</div>